<template>
    <transition name="fade-popup">
        <div v-if="visible" class="transparent-overlay" @click.self="handleClick" :style="{ backgroundColor: bgColor }">
            <div class="transparent-overlay-content" >
              <slot></slot>
            </div>
        </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      bgColor: {
        type: String,
        default: 'rgba(0, 0, 0, 0.6)'
      },
     
      clickOutsideToHide: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      handleClick() {
        if (this.clickOutsideToHide) {
            // 相当于父组件执行了visible = false
            this.$emit('update:visible', false);
            this.$emit('close')
        }
      }
    },
  };
  </script>
  
  <style lang="less" scoped>
  .transparent-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  
  .transparent-overlay-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    border-radius: 5px;
  }
  .fade-popup-enter-active,
  .fade-popup-leave-active {
    transition: opacity 0.3s ease-in-out;
  }
  .fade-popup-enter {
    opacity: 0;
  }
  .fade-popup-enter-to {
    opacity: 1;
  }
  .fade-popup-leave {
    opacity: 1;
  }
  .fade-popup-leave-to {
    opacity: 0;
  }
  </style>
  